import React from "react";

interface LabeledBoxProps {
  isRtl?: boolean;
  label: React.ReactNode;
  label2?: React.ReactNode;
  info?: string;
  children?: React.ReactNode;
  className?: string;
  row?: boolean;
  col?: boolean;
  wrap?: boolean;
  border?: boolean;
  shadow?: boolean;
  gap?: number;
  padding?: number;
  bgColor?: string;
  labelBgColor?: string;
  labelBorderColor?: string;
  label2Color?: string;
}

const LabeledBox: React.FC<LabeledBoxProps> = ({
  isRtl = false,
  label,
  label2,
  info,
  children,
  className = "",
  row = false,
  wrap = false,
  border = false,
  shadow = false,
  gap = 3,
  padding = 2,
  bgColor = "bg-white text-gray-600",
  labelBgColor = "bg-white",
  labelBorderColor = "border-gray-200 dark:border-gray-600",
  label2Color = "",
}) => {

  const dirClass = isRtl ? "rtl text-right" : "ltr text-left";
  const labelPositionClass = isRtl ? "left-4" : "right-4";
  const label2PositionClass = isRtl ? "right-4" : "left-4";

  // Tailwind does not support dynamic class names like `p-${padding}` or `gap-${gap}`
  // We can compute them manually using a mapping
  const paddingClass = `p-${padding}`;
  const gapClass = `gap-${gap}`;

  return (
    <div
      className={`relative border border-gray-200 dark:bg-gray-950 dark:text-gray-50 dark:border-gray-600 rounded-2xl ${bgColor} shadow-lg hover:shadow-xl transition-shadow duration-300 pt-4 ${paddingClass} ${info ? "pt-9" : ""
        } ${className} mb-6 mt-3`}
    >
      {/* Label */}
      {label && (
        <span
          className={`absolute z-20 -top-3 ${labelPositionClass} ${dirClass} ${labelBgColor} rounded-lg px-3 text-sm font-medium ${labelBorderColor} ${shadow && "shadow-sm"
            } ${border && "border"}`}
        >
          {label}
        </span>
      )}

      {/* Label right top */}
      {label2 && (
        <span
          className={`absolute z-20 -top-3 ${label2PositionClass} ${dirClass} ${label2Color} rounded-lg px-3 text-sm font-medium`}
        >
          {label2}
        </span>
      )}

      {/* Info */}
      {info && (
        <div className="absolute flex px-2 pt-1 line-clamp-2 -mt-6 text-[11px] text-gray-600 leading-none">
          {info}
        </div>
      )}

      {/* Content */}
      <div
        dir={isRtl ? "rtl" : "ltr"}
        className={`relative ${dirClass}  dark:bg-gray-950 dark:text-gray-50 dark:border-gray-600 rounded-2xl ${bgColor}  transition-shadow duration-300 pt-4 ${paddingClass} ${info ? "pt-9" : ""
          } ${className} mb-3 mt-3`}
      >
        {children}
      </div>
    </div>
  );
};

export default LabeledBox;